module.exports = __webpack_public_path__ + "img/close-outline.54bff975.svg";